import { Bell, ClipboardList, type LucideIcon } from 'lucide-react'
import type { Notification } from '../../../types/notifications'

/**
 * Maps a notification to the icon that best represents what it is about.
 * Driven by `data.event` so the Notification type itself stays generic and
 * new event types just need a new entry here.
 */
const EVENT_ICONS: Record<string, LucideIcon> = {
  survey_response_submitted: ClipboardList,
}

const DEFAULT_ICON: LucideIcon = Bell

export function iconForNotification(notification: Notification): LucideIcon {
  const event = notification.data?.event
  if (typeof event === 'string' && event in EVENT_ICONS) {
    return EVENT_ICONS[event]
  }
  return DEFAULT_ICON
}
